<script>
    import R, {LOADER} from "../lib/requests";
    import app from "../stores/app";
    import {setFocusTo} from "../lib/lib";
    import Modal from '../components/modal/Modal.svelte';
    import CodeControl from "../components/controls/CodeControl.svelte";
    import Notifier from "../stores/notifier";
    import Alert from "../stores/alerts";
    import AppIcon from "../components/icons/AppIcon.svelte";

    export let clientId = null;
    export let closeCallback;

    let client = null;
    let isDirty = false;
    let cloudLink = null;

    const initialize = () => {
        if (clientId == 0) {
            client = {
                id: 0,
                code: '',
                name: '',
                company: '',
                occupation: '',
                afm: '',
                address: '',
                city: '',
                zip_code: '',
                phone: '',
                fax: '',
                email: '',
                notes: '',
                cloud_key: '',
            }
            setFocusTo('clientCompany');
        } else {
            load();
        }
    }

    const load = () => {

        const onSuccess = result => {
            client = result;
            setFocusTo('clientCompany');
        };

        const onFailure = err => {
            console.log(err);
        };

        R.handle(R.client.details, clientId, onSuccess, onFailure, LOADER.POPUP);
    };


    const save = () => {
        const onSuccess = result => {
            Notifier.showMessage("Ο πελάτης ενημερώθηκε");
            isDirty = false;
            close(result);
        }

        const onFailure = err => {
            if (err.code && err.code === 'same_object_identifier') {
                Notifier.showError(`Υπάρχει ήδη καταχωρημένος πελάτης με τον κωδικό που εισάγατε!`);
                setFocusTo("clientCode");
                return;
            }
            if (err.message) {
                Notifier.showError(err.message);
            }
        };


        client.name = client.name.trim();
        client.company = client.company.trim();
        client.email = client.email.trim();
        if (!client.company) {
            Notifier.showError("Πληκτρολογήστε την επωνυμία επιχείρησης");
            setFocusTo("clientCompany");
            return;
        }

        let action = clientId == 0 ? 'create' : 'edit';
        R.handle(R.client[action], client, onSuccess, onFailure, LOADER.POPUP);
    }

    const close = (param) => {
        if (isDirty) {
            confirmClose();
            return;
        }

        client = null;

        if (param instanceof Event) {
            closeCallback();
            return;
        }

        setTimeout(() => {
            closeCallback(param);
        }, 200);
    }

    const onChange = () => {
        isDirty = true;
    }

    // Check if client data changed before closing the modal form
    const onBeforeClose = () => {
        if (isDirty) {
            confirmClose();
            return false;
        }

        return true;
    }

    const confirmClose = () => {
        Alert.confirmExit("Στοιχεία Πελάτη", "Έχετε κάνει αλλαγές στα στοιχεία του πελάτη.\nΘέλετε να αποχωρήσετε;",
            () => {
                isDirty = false;
                close();
            }
        );
    }

    const generateApiKey = () => {
        let d = new Date().getTime();

        if (window.performance && typeof window.performance.now === "function") {
            d += performance.now();
        }

        let key = 'xxxxx-xxxxx-yxxxx-xxxxxxx'.replace(/[xy]/g, function (c) {
            let r = (d + Math.random() * 16) % 16 | 0;
            d = Math.floor(d / 16);
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });

        return key;
    }

    const createCloudKey = () => {
        client.cloud_key = generateApiKey();
        isDirty = true;
    }

    const removeCloudKey = () => {
        Alert.delete("Κλειδί πελάτη", "Να διαγραφεί το κλειδί του πελάτη;\nΟ πελάτης δεν θα έχει πρόσβαση στις αναλύσεις του.", () => {
            client.cloud_key = null;
            isDirty = true;
        });
    }

    const copyCloudKey = async () => {
        try {
            await navigator.clipboard.writeText(cloudLink);
            Notifier.showMessage("Η διεύθυνση έχει αντιγραφεί στο πρόχειρο");
        } catch (err) {
            Notifier.showError("Δεν είναι δυνατή η αντιγραφή της διεύθυνσης!");
        }
    }

    initialize();

    $: if (client && client.cloud_key) {
        cloudLink = $app.cloud_url + "/" + client.cloud_key;
    } else {
        cloudLink = null;
    }
</script>

{#if client}
    <Modal modalMd title="Στοιχεία πελάτη" on:close="{ close }" onBeforeClose="{ onBeforeClose }">
        <div slot="body">
            <div class="row">
                <div class="col-lg-6">
                    <div class="form-group">
                        <label>Κωδικός</label>
                        <CodeControl id="clientCode" bind:value="{ client.code }" on:change={ onChange }/>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-6">
                    <div class="form-group">
                        <label>Επωνυμία Επιχείρησης</label>
                        <input type="text" class="form-control" id="clientCompany" bind:value="{ client.company }"
                               on:change={ onChange }>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="form-group">
                        <label>Α.Φ.Μ.</label>
                        <input type="text" class="form-control" bind:value="{ client.afm }" on:change={ onChange }>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-6">
                    <div class="form-group">
                        <label>Όνομα Υπεύθυνου</label>
                        <input type="text" class="form-control" bind:value="{ client.name }"
                               on:change={ onChange }>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="form-group">
                        <label>Είδος Επιχείρησης</label>
                        <input type="text" class="form-control" bind:value="{ client.occupation }"
                               on:change={ onChange }>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-6">
                    <div class="form-group">
                        <label>Τηλέφωνο</label>
                        <input type="tel" class="form-control" bind:value="{ client.phone }"
                               on:change={ onChange }>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="form-group">
                        <label>Fax</label>
                        <input type="tel" class="form-control" bind:value="{ client.fax }"
                               on:change={ onChange }>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-6">
                    <div class="form-group">
                        <label>Email</label>
                        <input type="email" class="form-control" bind:value="{ client.email }"
                               on:change={ onChange }>
                    </div>
                </div>
                <div class="col-lg-6">
                    <label>Κλειδί πελάτη</label>
                    <div class="form-group">
                        <div class="input-group mb-1">
                            <input type="text" class="form-control" bind:value="{ client.cloud_key }" readonly>
                            {#if !client.cloud_key}
                                <button class="btn btn-outline-secondary" type="button" title="δημιουργία κλειδιού"
                                        on:click={ createCloudKey }>
                                    <AppIcon icon="key"/>
                                </button>
                            {:else}
                                <button class="btn btn-outline-secondary" type="button" title="αντιγραφή διεύθυνσης"
                                        on:click={ copyCloudKey }>
                                    <AppIcon icon="copy"/>
                                </button>
                                <button class="btn btn-outline-danger" type="button" title="διαγραφή κλειδιού"
                                        on:click={ removeCloudKey }>
                                    <AppIcon icon="trash"/>
                                </button>
                            {/if}
                        </div>
                        {#if cloudLink}
                            <a href="{ cloudLink }" target="_blank">{ cloudLink }</a>
                        {/if}
                    </div>
                </div>
            </div>
            <hr>
            <div class="row">
                <div class="col-lg-6">
                    <div class="form-group">
                        <label>Διεύθυνση</label>
                        <input type="text" class="form-control" bind:value="{ client.address }"
                               on:change={ onChange }>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="form-group">
                        <label>Πόλη</label>
                        <input type="text" class="form-control" bind:value="{ client.city }"
                               on:change={ onChange }>
                    </div>
                </div>
                <div class="col-lg-2">
                    <div class="form-group">
                        <label>Τ.Κ.</label>
                        <input type="text" class="form-control" bind:value="{ client.zip_code }"
                               on:change={ onChange }>
                    </div>
                </div>
            </div>
            <textarea class="form-control" bind:value="{ client.notes }" on:change={ onChange }
                      placeholder="σημειώσεις"></textarea>
            <hr>
            <div class="text-end">
                <div class="btn btn-link me-4" on:click="{ () => close() }">Κλείσιμο</div>
                <button class="btn btn-primary px-4" on:click="{ save }">Ενημέρωση</button>
            </div>
        </div>
    </Modal>
{/if}